import {
  PageResource,
  PageStatus,
  FundsReleaseMode,
} from 'src/helpers/api/pages';
import { PageState } from 'src/redux/modules/page';

export function isActive(page: { status: PageStatus }): boolean {
  return [
    'Active',
    'TargetNotReached',
    'FullyFunded',
    'ReportGenerated',
    'Suspended',
  ].includes(page.status);
}

export function canPageReceiveDonations(page: { status: PageStatus }): boolean {
  return page.status === 'Active';
}

export function isClosed(page: { status: PageStatus }) {
  return ['FullyFunded', 'TargetNotReached', 'ReportGenerated'].includes(
    page.status
  );
}

export function isEligibleForFlexiblePayments(page: {
  fundsReleaseMode?: FundsReleaseMode;
}) {
  return page.fundsReleaseMode === 'OnDemand';
}

export function canPostUpdates(page: PageState | PageResource) {
  return (
    page.isOwnerRequested &&
    (page.status === 'Active' ||
      page.status === 'FullyFunded' ||
      page.status === 'Suspended')
  );
}

export function isPendingApproval(page: PageState | PageResource) {
  return page.status === 'PendingApproval';
}



// WEBPACK FOOTER //
// ./src/helpers/page.ts